import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { DashboardPage } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/dashboard")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	return (
		<DashboardLayout>
			<DashboardPage />
		</DashboardLayout>
	);
}
